export default __webpack_public_path__ + "static/media/uploaded-image.da50269c.svg";